"use client";

import { useId, useState, type ButtonHTMLAttributes } from "react";

// Missing prerequisites explain the next action; only in-flight operations disable the button.
export function GuidedSubmitButton({ reason, onBlocked, focusSelector, onClick, children, ...props }: ButtonHTMLAttributes<HTMLButtonElement> & {
  reason?: string;
  onBlocked?: () => void;
  focusSelector?: string;
}) {
  const id = useId();
  const [attemptedReason, setAttemptedReason] = useState("");
  const visible = Boolean(reason && attemptedReason === reason);
  return <>
    <button {...props} aria-describedby={visible ? [props["aria-describedby"], id].filter(Boolean).join(" ") : props["aria-describedby"]}
      onClick={event => {
        if (reason) {
          event.preventDefault();
          setAttemptedReason(reason);
          const scope = event.currentTarget.closest("dialog") ?? event.currentTarget.form ?? event.currentTarget.closest("section");
          const target = focusSelector ? scope?.querySelector<HTMLElement>(focusSelector) : null;
          target?.scrollIntoView({ block: "center", behavior: "instant" });
          target?.focus({ preventScroll: true });
          onBlocked?.();
          return;
        }
        setAttemptedReason("");
        onClick?.(event);
      }}>{children}</button>
    {visible && <p id={id} role="alert" className="rg-error text-sm">{reason}</p>}
  </>;
}
